import {spaceAndRoundNumber} from '@/libs/number.util';
import {ClientTypes} from '@/libs/constants/common.constants';
import {useTranslations} from 'next-intl';

export default function ProductPrice({ price, clientType, className = '' }) {
  const t = useTranslations('product');
  return (
      <div className={`product-price ${className}`}>
        <span>
          {price.currencyObj.left ? (<span className="currency-sign-font">{price.currencyObj.symbol}</span>) : ''}
          <span data-currency={price.currencyObj.title}>{spaceAndRoundNumber(clientType === ClientTypes.WHOLESALER && price.wholesalePrice != null ? price.wholesalePrice : price.priceComputed)}</span>
          {!price.currencyObj.left ? (<span className="currency-sign-font">{price.currencyObj.symbol}</span>) : ''}
        </span>
        {' '}
        {
          clientType === ClientTypes.WHOLESALER && price.wholesalePrice != null ? (
              <span className="wholesale-word">{t('wholesale')}</span>
          ) : (
              price.overpriceComputed > 0 ? (
                  <span className={`pr-overprice ${price.crossed ? 'cross-word' : 'text-through'}`}>
                    {price.currencyObj.left ? (<span className="currency-sign-font">{price.currencyObj.symbol}</span>) : ''}
                    <span data-currency={price.currencyObj.title}>{spaceAndRoundNumber(price.overpriceComputed)}</span>
                    {!price.currencyObj.left ? (<span className="currency-sign-font">{price.currencyObj.symbol}</span>) : ''}
                  </span>
              ) : ''
          )
        }
      </div>
  );
};
